export const colors = [
	'#0047FF',
	'#FD3C3C',
	'#F08025',
	'#45C2A4',
	'#0E6B39',
	'#6E3CFD',
	'#A8AA43',
	'#DB1B77',
	'#79F786',
	'#8682B7',
	'#00D1FF',
	'#8DBF44'
];
